import { memo, useEffect, useState } from "react";

// material-ui
import { Typography } from "@mui/material";

// project imports
import NavGroup from "./NavGroup";
import {
  getNotification,
  notificationAlert,
  getUnreadData,
  getApplicationUnreadData,
} from "store/slices/notificationAction";
import { useLocation } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { getAllChat } from "../../../../store/slices/firebaseAction";
import { getStaffSupportNotification } from "store/slices/supportStaffAction";
import {
  IconBellRinging,
  IconBuildingSkyscraper,
  IconClipboardList,
  IconDeviceAnalytics,
  IconMessages,
  IconHelp,
  IconAd,
  IconLockAccess,
  IconLicense,
  IconBuildingCommunity,
  IconApps,
  IconHome,
  IconHistory,
  IconBrandLinktree,
  IconShoppingCart,
  IconBuilding,
} from "@tabler/icons";
import useRecursiveTimeout from "../MenuList/useRecursiveTimeout";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = (props) => {
  const location = useLocation();
  const { ownerLabelsName } = props.label;
  const [staffSupportUnread, setStaffSupportUnread] = useState(0);
  const [appliedUnread, setAppliedUnread] = useState(0);
  const notifications = useSelector((state) => state.notifications);
  const { notificationLoading, notificationList, notificationData } =
    notifications;

  useEffect(() => {
    const userId = localStorage.getItem("ownerId");
    props.getAllChat("", userId);
  }, []);

  const unreads = notificationData;

  const chatState = useSelector((state) => state.chats.chats);
  const unreadChats = chatState[0]?.unreads;

  useEffect(() => {
    props.getUnreadData();
  }, []);

  useEffect(() => {
    props.getApplicationUnreadData().then((res) => {
      setAppliedUnread(res.pendingCount);
    });
  }, []);

  useRecursiveTimeout(async () => {
    props.getApplicationUnreadData().then((res) => {
      setAppliedUnread(res.pendingCount);
    });
  }, 10000);



  useEffect(() => {
    props.getNotification(1, 20, "");
  }, []);

  useRecursiveTimeout(async () => {
    props.getUnreadData();
  }, 10000);


  useEffect(() => {
    props.getStaffSupportNotification().then((res) => {
      setStaffSupportUnread(res.unread);
    });
  }, []);

  useRecursiveTimeout(async () => {
    props.getStaffSupportNotification().then((res) => {
      setStaffSupportUnread(res.unread);
    });
  }, 10000);



  const other = {
    id: "sample-docs-roadmap",
    type: "group",
    children: [
      {
        id: "Dashboard",

        title: (
          <FormattedMessage
            id={
              ownerLabelsName
                ? ownerLabelsName.filter((e) => e.key == "lbl_dashboard").length > 0
                  ? ownerLabelsName.filter((e) => e.key == "lbl_dashboard")[0][
                      "value"
                    ] || "lbl_dashboard"
                  : "lbl_dashboard"
                : "lbl_dashboard"
            }
          />
        ),
        type: "item",
        url: "/dashboard",
        icon: IconClipboardList,
        breadcrumbs: false,
      },
      {
        id: "Register Property",
        title: (
          <FormattedMessage
            id={
              ownerLabelsName
                ? ownerLabelsName.filter((e) => e.key == "lbl_register_property")
                    .length > 0
                  ? ownerLabelsName.filter(
                      (e) => e.key == "lbl_register_property"
                    )[0]["value"] || "lbl_register_property"
                  : "lbl_register_property"
                : "lbl_register_property"
            }
          />
        ),
        type: "item",
        url: "/property/register",
        icon: IconHome,
        breadcrumbs: false,
      },
      {
        id: "Susbscription History",
        title: (
          <FormattedMessage
            id={
              ownerLabelsName
                ? ownerLabelsName.filter((e) => e.key == "lbl_subscription").length >
                  0
                  ? ownerLabelsName.filter((e) => e.key == "lbl_subscription")[0][
                      "value"
                    ] || "lbl_subscription"
                  : "lbl_subscription"
                : "lbl_subscription"
            }
          />
        ),
        type: "item",
        url: "/subscription-history",
        icon: IconHistory,
        breadcrumbs: false,
      },
      {
        id: "Chat",
        title: (
          <FormattedMessage
            id={
              ownerLabelsName
                ? ownerLabelsName.filter((e) => e.key == "lbl_chat").length > 0
                  ? ownerLabelsName.filter((e) => e.key == "lbl_chat")[0]["value"] ||
                    "lbl_chat"
                  : "lbl_chat"
                : "lbl_chat"
            }
          />
        ),
        type: "item",
        url: "/chat",
        icon: IconMessages,
        breadcrumbs: false,
        chip: {
          label: unreadChats || 0,
          color: "primary",
        },
      },
      // {
      //   id: "Notification",
      //   title: (
      //     <FormattedMessage
      //       id={
      //         ownerLabelsName
      //           ? ownerLabelsName.filter((e) => e.key == "lbl_notification").length >
      //             0
      //             ? ownerLabelsName.filter((e) => e.key == "lbl_notification")[0][
      //                 "value"
      //               ] || "lbl_notification"
      //             : "lbl_notification"
      //           : "lbl_notification"
      //       }
      //     />
      //   ),
      //   type: "item",
      //   url: "/notification",
      //   icon: IconBellRinging,
      //   breadcrumbs: false,
      //   chip: {
      //     label: unreads,
      //     color: "primary",
      //   },
      // },
      {
        id: "Tenant List",
        title: (
          <FormattedMessage
            id={
              ownerLabelsName
                ? ownerLabelsName.filter((e) => e.key == "lbl_tenant_list").length >
                  0
                  ? ownerLabelsName.filter((e) => e.key == "lbl_tenant_list")[0][
                      "value"
                    ] || "lbl_tenant_list"
                  : "lbl_tenant_list"
                : "lbl_tenant_list"
            }
          />
        ),
        type: "item",
        url: "/tenant-list",
        icon: IconLockAccess,
        breadcrumbs: false,
      },
      {
        id: "leigulistinn",
        title: (
          <FormattedMessage
            id={
              ownerLabelsName
                ? ownerLabelsName.filter((e) => e.key == "lbl_all_properties")
                    .length > 0
                  ? ownerLabelsName.filter((e) => e.key == "lbl_all_properties")[0][
                      "value"
                    ] || "lbl_all_properties"
                  : "lbl_all_properties"
                : "lbl_all_properties"
            }
          />
        ),
        type: "item",
        url: "/all-properties",
        icon: IconBuilding,
        breadcrumbs: false,
      },

      {
        id: "Properties",
        title: (
          <FormattedMessage
            id={
              ownerLabelsName
                ? ownerLabelsName.filter((e) => e.key == "lbl_properties").length > 0
                  ? ownerLabelsName.filter((e) => e.key == "lbl_properties")[0][
                      "value"
                    ] || "lbl_properties"
                  : "lbl_properties"
                : "lbl_properties"
            }
          />
        ),
        type: "collapse",
        url: "/properties",
        icon: IconBuildingSkyscraper,
        breadcrumbs: false,
        children: [
          // {
          //   id: "My Properties",
          //   title: (
          //     <FormattedMessage
          //       id={
          //         ownerLabelsName
          //           ? ownerLabelsName.filter((e) => e.key == "lbl_my_properties")
          //               .length > 0
          //             ? ownerLabelsName.filter(
          //                 (e) => e.key == "lbl_my_properties"
          //               )[0]["value"] || "lbl_my_properties"
          //             : "lbl_my_properties"
          //           : "lbl_my_properties"
          //       }
          //     />
          //   ),
          //   type: "item",

          //   icon: IconApps,
          //   breadcrumbs: false,
          // },
          {
            id: "Purchase Ads",
            title: (
              <FormattedMessage
                id={
                  ownerLabelsName
                    ? ownerLabelsName.filter((e) => e.key == "lbl_all_ads").length >
                      0
                      ? ownerLabelsName.filter((e) => e.key == "lbl_all_ads")[0][
                          "value"
                        ] || "lbl_all_ads"
                      : "lbl_all_ads"
                    : "lbl_all_ads"
                }
              />
            ),
            type: "item",
            url: "/purchase-ads",
            icon: IconAd,
            breadcrumbs: false,
          },
          // {
          //   id: "Rental Servive",
          //   title: (
          //     <FormattedMessage
          //       id={
          //         ownerLabelsName
          //           ? ownerLabelsName.filter((e) => e.key == "lbl_rental_service")
          //             .length > 0
          //             ? ownerLabelsName.filter(
          //               (e) => e.key == "lbl_rental_service"
          //             )[0]["value"] || "lbl_rental_service"
          //             : "lbl_rental_service"
          //           : "lbl_rental_service"
          //       }
          //     />
          //   ),
          //   type: "item",
          //   url: "/rental-service",
          //   icon: IconBrandLinktree,
          //   breadcrumbs: false,
          // },
          {
            id: "Applications",
            title: (
              <FormattedMessage
                id={
                  ownerLabelsName
                    ? ownerLabelsName.filter((e) => e.key == "lbl_applications")
                        .length > 0
                      ? ownerLabelsName.filter(
                          (e) => e.key == "lbl_applications"
                        )[0]["value"] || "lbl_applications"
                      : "lbl_applications"
                    : "lbl_applications"
                }
              />
            ),
            type: "item",
            url: "/applications",
            icon: IconApps,
            breadcrumbs: false,
            chip: {
              label: appliedUnread,
              color: "primary",
            },
          },
          {
            id: "Contracts",
            title: (
              <FormattedMessage
                id={
                  ownerLabelsName
                    ? ownerLabelsName.filter((e) => e.key == "lbl_rental_contracts")
                        .length > 0
                      ? ownerLabelsName.filter(
                          (e) => e.key == "lbl_rental_contracts"
                        )[0]["value"] || "lbl_rental_contracts"
                      : "lbl_rental_contracts"
                    : "lbl_rental_contracts"
                }
              />
            ),
            type: "item",
            url: "/rental-agreement-template",
            icon: IconLicense,
            breadcrumbs: false,
          },
          {
            id: "Reported Properties",
            title: (
              <FormattedMessage
                id={
                  ownerLabelsName
                    ? ownerLabelsName.filter(
                        (e) => e.key == "lbl_reported_properties"
                      ).length > 0
                      ? ownerLabelsName.filter(
                          (e) => e.key == "lbl_reported_properties"
                        )[0]["value"] || "lbl_reported_properties"
                      : "lbl_reported_properties"
                    : "lbl_reported_properties"
                }
              />
            ),
            type: "item",
            url: "/reported-properties",
            icon: IconBuildingCommunity,
            breadcrumbs: false,
          },
        ],
      },
      {
        id: "Staff Support",
        title: (
          <FormattedMessage
            id={
              ownerLabelsName
                ? ownerLabelsName.filter((e) => e.key == "lbl_staff_support")
                    .length > 0
                  ? ownerLabelsName.filter((e) => e.key == "lbl_staff_support")[0][
                      "value"
                    ] || "lbl_staff_support"
                  : "lbl_staff_support"
                : "lbl_staff_support"
            }
          />
        ),
        type: "item",
        url: "/staff-support",
        icon: IconHelp,
        breadcrumbs: false,
        chip: {
          label: staffSupportUnread,
          color: "primary",
        },
      },

      // {
      //   id: "Analytics",
      //   title: (
      //     <FormattedMessage
      //       id={
      //         ownerLabelsName
      //           ? ownerLabelsName.filter((e) => e.key == "lbl_analytics").length > 0
      //             ? ownerLabelsName.filter((e) => e.key == "lbl_analytics")[0][
      //                 "value"
      //               ] || "lbl_analytics"
      //             : "lbl_analytics"
      //           : "lbl_analytics"
      //       }
      //     />
      //   ),
      //   type: "item",
      //   url: "/analytics",
      //   icon: IconDeviceAnalytics,
      //   breadcrumbs: false,
      // },

      // {
      //   id: "Subscription",
      //   title: (
      //     <FormattedMessage
      //       id={
      //         ownerLabelsName
      //           ? ownerLabelsName.filter((e) => e.key == "lbl_Subscription").length >
      //             0
      //             ? ownerLabelsName.filter((e) => e.key == "lbl_Subscription")[0][
      //                 "value"
      //               ] || "lbl_Subscription"
      //             : "lbl_Subscription"
      //           : "lbl_Subscription"
      //       }
      //     />
      //   ),
      //   type: "item",
      //   url: "/subscription",
      //   icon: IconLockAccess,
      //   breadcrumbs: false,
      // },
      // {
      //   id: "Leigjendaskrá",
      //   title: <FormattedMessage id="Leigjendaskrá" />,
      //   type: "item",
      //   url: "/leigjendaskra",
      //   icon: IconLockAccess,
      //   breadcrumbs: false,
      // },
    ],
  };

  const menuItems = {
    items: [other],
  };

  const navItems = menuItems.items.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

const mapStateToProps = (state) => ({
  label: state.language,
});

export default connect(mapStateToProps, {
  getNotification,
  notificationAlert,
  getUnreadData,
  getAllChat,
  getStaffSupportNotification,
  getApplicationUnreadData,
})(memo(MenuList));
